import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  IconButton,
  MenuItem,
  Tooltip,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Edit,
  Delete,
  FormatBold,
  FormatItalic,
  FormatUnderlined,
  FormatListBulleted,
  Link,
  Undo,
  Redo,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";

import Resume1 from "../DuplicateResume/Resume1";
import Resume2 from "../DuplicateResume/Resume2";
import Resume3 from "../DuplicateResume/Resume3";
import Resume4 from "../DuplicateResume/Resume4";
import Resume5 from "../DuplicateResume/Resume5";
import Resume6 from "../DuplicateResume/Resume6";
import Resume7 from "../DuplicateResume/Resume7";
import Resume8 from "../DuplicateResume/Resume8";
import Resume9 from "../DuplicateResume/Resume9";
import Resume10 from "../DuplicateResume/Resume10";
import Resume11 from "../DuplicateResume/Resume11";
import Resume12 from "../DuplicateResume/Resume12";
import Resume13 from "../DuplicateResume/Resume13";
import Resume14 from "../DuplicateResume/Resume14";
import Resume15 from "../DuplicateResume/Resume15";
import Resume16 from "../DuplicateResume/Resume16";
import Resume17 from "../DuplicateResume/Resume17";
import Resume18 from "../DuplicateResume/Resume18";
import Resume19 from "../DuplicateResume/Resume19";
import Resume20 from "../DuplicateResume/Resume20";  
import Resume21 from "../DuplicateResume/Resume21";
import Resume22 from "../DuplicateResume/Resume22";
import Resume23 from "../DuplicateResume/Resume23";
import Resume24 from "../DuplicateResume/Resume24";
import Resume25 from "../DuplicateResume/Resume25";
import Resume26 from "../DuplicateResume/Resume26";
import Resume27 from "../DuplicateResume/Resume27";
import Resume28 from "../DuplicateResume/Resume28";
import Resume29 from "../DuplicateResume/Resume29";
import Resume30 from "../DuplicateResume/Resume30";
import Resume31 from "../DuplicateResume/Resume31";
import Resume32 from "../DuplicateResume/Resume32";
import Resume33 from "../DuplicateResume/Resume33";
import Resume34 from "../DuplicateResume/Resume34";
import Resume35 from "../DuplicateResume/Resume35";
import Resume36 from "../DuplicateResume/Resume36";

import Resume37 from "../DuplicateResume/Resume37";
import Resume38 from "../DuplicateResume/Resume38";
import Resume39 from "../DuplicateResume/Resume39";
import Resume40 from "../DuplicateResume/Resume40";
import Resume41 from "../DuplicateResume/Resume41";
import Resume42 from "../DuplicateResume/Resume42";
import Resume43 from "../DuplicateResume/Resume43";
import Resume44 from "../DuplicateResume/Resume44";
import Resume45 from "../DuplicateResume/Resume45";
import Resume46 from "../DuplicateResume/Resume46";
import Resume47 from "../DuplicateResume/Resume47";
import Resume48 from "../DuplicateResume/Resume48";
import Resume49 from "../DuplicateResume/Resume49";
import Resume50 from "../DuplicateResume/Resume50";

const WorkExperienceList = () => {
  const [works, setWorks] = useState([]);
  const [showForm, setShowForm] = useState(false);

  // ✅ ADDED: Student popup dialog state
  const [studentDialog, setStudentDialog] = useState(false);
  // ✅ ADDED: Secondary School popup dialog state
  const [secondaryDialog, setSecondaryDialog] = useState(false);

  const templateComponents = {
  1: Resume1,
  2: Resume2,
  3: Resume3,
  4: Resume4,
  5: Resume5,
  6: Resume6,
  7: Resume7,
  8: Resume8,
  9: Resume9,
  10: Resume10,
  11: Resume11, 
  12: Resume12,
  13: Resume13,
  14: Resume14,
  15: Resume15,
  16: Resume16,
  17: Resume17,
  18: Resume18,
  19: Resume19,
  20: Resume20,
  21: Resume21,
  22: Resume22,
  23: Resume23,
  24: Resume24,
  25: Resume25,
  26: Resume26,
  27: Resume27,
  28: Resume28,
  29: Resume29,
 30: Resume30,
 31: Resume31,
  32: Resume32,
 33: Resume33,
 34:Resume34,
 35: Resume35,
 36: Resume36,
  37: Resume37,
  38: Resume38, 
   39:Resume39,
   40:Resume40,
    41:Resume41,
  42:Resume42,
    43:Resume43,
 44:Resume44,
 45:Resume45,
 46:Resume46,
 47:Resume47,
 48:Resume48,
49:Resume49,
50:Resume50,
};

  const [editingIndex, setEditingIndex] = useState(null);
  const [form, setForm] = useState({
    jobTitle: "",
    employer: "",
    companyName: "",
    location: "",
    startMonth: "",
    startYear: "",
    endMonth: "",
    endYear: "",
    current: false,
    description: "",
  });
  const [history, setHistory] = useState([]);
  const [redoStack, setRedoStack] = useState([]);

  const navigate = useNavigate();

  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Persist template/theme across navigation
  const [selectedTemplate, setSelectedTemplate] = useState(() => {
    const navTemplate = location.state?.selectedTemplate;
    if (navTemplate) {
      localStorage.setItem("selectedTemplate", navTemplate);
      return navTemplate;
    }
    return localStorage.getItem("selectedTemplate") || 1;
  });
  const [selectedTheme, setSelectedTheme] = useState(() => {
    const navTheme = location.state?.selectedTheme;
    const parseTheme = (t) => {
      if (!t) return null;
      if (typeof t === 'string') return t;
      if (typeof t === 'object') return t.primary || t.color || t.highlight || t.primary?.main || t.hex || null;
      return null;
    };

    const fromNav = parseTheme(navTheme);
    if (fromNav) {
      localStorage.setItem('selectedTheme', fromNav);
      return fromNav;
    }

    const stored = localStorage.getItem('selectedTheme');
    if (!stored) return '#1a2b47';
    try {
      const parsed = JSON.parse(stored);
      const fromParsed = parseTheme(parsed);
      return fromParsed || stored || '#1a2b47';
    } catch {
      return stored;
    }
  });

  // If navigation state changes and has new template/theme, update state and localStorage
  useEffect(() => {
    if (location.state) {
      const { selectedTemplate: template, selectedTheme: theme } = location.state;
      if (template) {
        setSelectedTemplate(template);
        localStorage.setItem("selectedTemplate", template);
      }
      if (theme) {
        const normalized = typeof theme === 'string' ? theme : (theme.primary || theme.color || theme.highlight || theme.primary?.main || theme.hex || null);
        if (normalized) {
          setSelectedTheme(normalized);
          localStorage.setItem('selectedTheme', normalized);
        }
      }
    }
  }, [location.state]);

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  
  // ✅ FIXED: Dynamic current year and extended to 2040
  const currentYear = new Date().getFullYear();
  // Years from 1940 to 2040 (includes future years up to 2040)
  const years = Array.from({ length: 101 }, (_, i) => 1940 + i);
  // Years from 1940 to current year for start year
  const startYears = years.filter(year => year <= currentYear);
  // ✅ FIXED: End Year only shows years >= selected Start Year and up to 2040
  const endYears = form.startYear
    ? years.filter((year) => year >= parseInt(form.startYear) && year <= 2040)
    : years.filter(year => year <= 2040);

  // ✅ Load from localStorage
  useEffect(() => {
    const savedWorks = localStorage.getItem("workExperiences");
    const singleWork = localStorage.getItem("workExperience");
    
    let allWorks = [];
    
    if (savedWorks) {
      allWorks = JSON.parse(savedWorks);
    }
    
    if (singleWork) {
      const workData = JSON.parse(singleWork);
      
      // Ensure all required fields exist with default values
      const completeWorkData = {
        jobTitle: workData.jobTitle || "",
        employer: workData.employer || "",
        companyName: workData.companyName || "",
        location: workData.location || "",
        startMonth: workData.startMonth || "",
        startYear: workData.startYear || "",
        endMonth: workData.endMonth || "",
        endYear: workData.endYear || "",
        current: workData.current || false,
        description: workData.description || "",
      };
      
      const exists = allWorks.some(work => 
        work.jobTitle === completeWorkData.jobTitle && 
        work.employer === completeWorkData.employer &&
        work.startYear === completeWorkData.startYear
      );
      
      if (!exists) {
        allWorks.push(completeWorkData);
        localStorage.setItem("workExperiences", JSON.stringify(allWorks));
        localStorage.removeItem("workExperience");
      }
    }
    
    setWorks(allWorks);
  }, []);

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ✅ Text formatting functions
  const applyFormat = (startTag, endTag) => {
    const textarea = document.getElementById("description-textarea");
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = form.description.substring(start, end);
    const newText =
      form.description.substring(0, start) +
      startTag +
      selectedText +
      endTag +
      form.description.substring(end);

    setHistory([...history, form.description]);
    setForm(prev => ({ ...prev, description: newText }));
    setRedoStack([]);
  };

  const undo = () => {
    if (history.length === 0) return;
    const prev = history[history.length - 1];
    setRedoStack([form.description, ...redoStack]);
    setHistory(history.slice(0, -1));
    setForm(prev => ({ ...prev, description: prev }));
  };

  const redo = () => {
    if (redoStack.length === 0) return;
    const next = redoStack[0];
    setHistory([...history, form.description]);
    setRedoStack(redoStack.slice(1));
    setForm(prev => ({ ...prev, description: next }));
  };

  // ✅ Format description text for display
  const formatDescription = (description) => {
    if (!description) return "";
    
    return description
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/<u>(.*?)<\/u>/g, '<u>$1</u>')
      .replace(/\n/g, '<br/>');
  };

  // ✅ Save to localStorage
  const saveToLocalStorage = (updatedWorks) => {
    setWorks(updatedWorks);
    localStorage.setItem("workExperiences", JSON.stringify(updatedWorks));
  };

  // ✅ Handle form submission (add or update)
  const handleSave = () => {
    let updatedWorks;
    
    if (editingIndex !== null) {
      updatedWorks = [...works];
      updatedWorks[editingIndex] = form;
    } else {
      updatedWorks = [...works, form];
    }
    
    saveToLocalStorage(updatedWorks);
    resetForm();
  };

  // ✅ Edit a work experience
  const handleEdit = (index) => {
    setForm(works[index]);
    setEditingIndex(index);
    setShowForm(true);
    setHistory([]);
    setRedoStack([]);
  };

  // ✅ Delete a work experience
  const handleDelete = (index) => {
    const updatedWorks = works.filter((_, i) => i !== index);
    saveToLocalStorage(updatedWorks);
  };

  // ✅ Reset form
  const resetForm = () => {
    setForm({
      jobTitle: "",
      employer: "",
      companyName: "",
      location: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      current: false,
      description: "",
    });
    setEditingIndex(null);
    setShowForm(false);
    setHistory([]);
    setRedoStack([]);
  };

  // Handle Go Back navigation to WorkHistry1
  const handleGoBack = () => {
    navigate("/WorkHistry1", {
      state: { selectedTemplate, selectedTheme },
    });
  };

  // ✅ ADDED: Check if user is a student or secondary school before showing form
  const handleAddWorkExperience = () => {
    const questionnaireAnswers = JSON.parse(
      localStorage.getItem("questionnaireAnswers") || "{}"
    );
    const isStudent = questionnaireAnswers.student === "Yes";
    const isSecondarySchool = questionnaireAnswers.education === "Secondary School";

    if (isStudent) {
      setStudentDialog(true);
    } else if (isSecondarySchool) {
      setSecondaryDialog(true);
    } else {
      setShowForm(true);
    }
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      {/* Main content area — pushed right of sidebar */}
      <Box
        sx={{
          ml: { xs: "60px", sm: "240px" },
          width: { xs: "calc(100% - 60px)", sm: "calc(100% - 240px)" },
          minHeight: "100vh",
          p: { xs: 1.5, sm: 3 },
          boxSizing: "border-box",
          backgroundColor: "#EFF7FF",
        }}
      >
        {/* Go Back Button */}
        <Typography
          variant="body2"
          sx={{
            color: "#002B5B",
            fontWeight: "bold",
            mb: 2,
            cursor: "pointer",
            "&:hover": {
              color: "#0288D1",
              textDecoration: "underline",
            },
            transition: "color 0.3s ease",
            fontSize: isSmallMobile ? "0.875rem" : "inherit",
          }}
          onClick={handleGoBack}
        >
          ← Go Back
        </Typography>

        {/* Header Section */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems={isMobile ? "flex-start" : "center"}
          mb={3}
          flexDirection={isMobile ? "column" : "row"}
          gap={isMobile ? 2 : 0}
        >
          <Typography 
            variant={isMobile ? "h5" : "h4"} 
            fontWeight="bold"
            sx={{ fontSize: isSmallMobile ? "1.5rem" : "1.5rem", color: "#002B5B" }}
          >
            Work Experiences
          </Typography>
          {/* ✅ CHANGED: onClick now calls handleAddWorkExperience instead of setShowForm(true) */}
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#002B5B",
              "&:hover": { backgroundColor: "#0288D1" },
              width: isMobile ? "100%" : "auto",
              maxWidth: isMobile ? "250px" : "none",
            }}
            onClick={handleAddWorkExperience}
          >
            + Add Work Experience
          </Button>
        </Box>

        {/* ✅ Show form if button clicked */}
        {showForm && (
          <Box
            sx={{
              p: isMobile ? 2 : 3,
              mb: 3,
              border: "1px solid #B3D9F7",
              borderLeft: "4px solid #002B5B",
              borderRadius: 2,
              background: "#EFF7FF",
            }}
          >
            <Typography variant={isMobile ? "h6" : "h5"} mb={2} sx={{ color: "#002B5B" }}>
              {editingIndex !== null ? "Edit Work Experience" : "Add Work Experience"}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Job Title"
                  name="jobTitle"
                  placeholder="e.g. Senior Software Engineer"
                  value={form.jobTitle}
                  onChange={handleChange}
                  required
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  size={isSmallMobile ? "small" : "medium"}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Role"
                  name="employer"
                  placeholder="e.g. Team Lead / Developer"
                  value={form.employer}
                  onChange={handleChange}
                  required
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  size={isSmallMobile ? "small" : "medium"}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Company Name"
                  name="companyName"
                  placeholder="e.g. Google, Microsoft, Amazon"
                  value={form.companyName}
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  onChange={handleChange}
                  size={isSmallMobile ? "small" : "medium"}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Location"
                  name="location"
                  placeholder="e.g. Chennai, India"
                  value={form.location}
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  onChange={handleChange}
                  size={isSmallMobile ? "small" : "medium"}
                />
              </Grid>
              
              {/* Start Date */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  select
                  label="Start Month"
                  name="startMonth"
                  placeholder="Select start month"
                  value={form.startMonth}
                  onChange={handleChange}
                  required
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  size={isSmallMobile ? "small" : "medium"}
                >
                  {months.map((month) => (
                    <MenuItem key={month} value={month}>
                      {month}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  select
                  label="Start Year"
                  name="startYear"
                  placeholder="Select start year"
                  value={form.startYear}
                  onChange={handleChange}
                  required
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  size={isSmallMobile ? "small" : "medium"}
                >
                  {startYears.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              
              {/* End Date */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  select
                  label="End Month"
                  name="endMonth"
                  placeholder="Select end month"
                  value={form.endMonth}
                  onChange={handleChange}
                  disabled={form.current}
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  size={isSmallMobile ? "small" : "medium"}
                >
                  {months.map((month) => (
                    <MenuItem key={month} value={month}>
                      {month}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  select
                  label="End Year"
                  name="endYear"
                  placeholder="Select end year"
                  value={form.endYear}
                  sx={{
                    width:{md:"250px",xs:"300px"},
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#B3D9F7" },
                      "&:hover fieldset": { borderColor: "#0288D1" },
                      "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                    },
                  }}
                  onChange={handleChange}
                  disabled={form.current}
                  size={isSmallMobile ? "small" : "medium"}
                >
                  {endYears.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.current}
                      onChange={handleChange}
                      name="current"
                      size={isSmallMobile ? "small" : "medium"}
                      sx={{
                        color: "#B3D9F7",
                        "&.Mui-checked": { color: "#002B5B" },
                      }}
                    />
                  }
                  label="I currently work here"
                />
              </Grid>
              
              {/* Rich Text Editor for Description */}
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom sx={{ color: "#002B5B" }}>
                  Description
                </Typography>
                <Box border={1} borderColor="#B3D9F7" borderRadius={1} p={1}>
                  {/* <Box 
                    display="flex" 
                    gap={1} 
                    mb={1} 
                    flexWrap="wrap"
                    justifyContent={isSmallMobile ? "center" : "flex-start"}
                  >
                    <Tooltip title="Bold">
                      <IconButton size="small" onClick={() => applyFormat("**", "**")}>
                        <FormatBold fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Italic">
                      <IconButton size="small" onClick={() => applyFormat("*", "*")}>
                        <FormatItalic fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Underline">
                      <IconButton size="small" onClick={() => applyFormat("<u>", "</u>")}>
                        <FormatUnderlined fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Bullet List">
                      <IconButton size="small" onClick={() => applyFormat("\n- ", "")}>
                        <FormatListBulleted fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Insert Link">
                      <IconButton size="small" onClick={() => applyFormat("[", "](https://)")}>
                        <Link fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Undo">
                      <IconButton size="small" onClick={undo} disabled={history.length === 0}>
                        <Undo fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Redo">
                      <IconButton size="small" onClick={redo} disabled={redoStack.length === 0}>
                        <Redo fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box> */}
                  
                  <TextField
                    id="description-textarea"
                    fullWidth
                    multiline
                    rows={isSmallMobile ? 3 : 4}
                    name="description"
                    placeholder="Describe your responsibilities and achievements... e.g. Led a team of 5 developers"
                    value={form.description || ""}
                    onChange={handleChange}
                    inputProps={{ maxLength: 90 }}
                    helperText={`${(form.description || "").length}/90 characters`}
                    variant="outlined"
                    size={isSmallMobile ? "small" : "medium"}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "#B3D9F7" },
                        "&:hover fieldset": { borderColor: "#0288D1" },
                        "&.Mui-focused fieldset": { borderColor: "#002B5B" },
                      },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
            <Box mt={2} display="flex" gap={2} flexDirection={isSmallMobile ? "column" : "row"}>
              <Button 
                variant="contained" 
                onClick={handleSave}
                disabled={
                  !form.jobTitle || !form.employer || !form.startMonth || !form.startYear || ((form.description || "").length > 90)
                }
                sx={{
                  width: isSmallMobile ? "100%" : "auto",
                  backgroundColor: "#002B5B",
                  "&:hover": { backgroundColor: "#0288D1" },
                }}
              >
                {editingIndex !== null ? "Update" : "Save"}
              </Button>
              <Button 
                variant="outlined" 
                onClick={resetForm}
                sx={{
                  width: isSmallMobile ? "100%" : "auto",
                  borderColor: "#002B5B",
                  color: "#002B5B",
                  "&:hover": {
                    borderColor: "#0288D1",
                    color: "#0288D1",
                    backgroundColor: "rgba(2, 136, 209, 0.04)",
                  },
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        )}

        {/* 🔥 Scrollable List */}
        <Box
          sx={{
            maxHeight: isMobile ? "400px" : "500px",
            overflowY: "auto",
            pr: 1,   
          }}
        >
          <Grid container spacing={2}>
            {Array.isArray(works) && works.length > 0 ? (
              works.map((work, index) => (
                <Grid item xs={12} key={index}>
                  <Card 
                    sx={{ 
                      boxShadow: 2, 
                      borderRadius: 2, 
                      width: "100%",
                      maxWidth: "100%",
                      border: "1px solid #B3D9F7",
                      borderLeft: "4px solid #002B5B",
                    }}
                  >
                    <CardContent sx={{ p: isSmallMobile ? 2 : 3 }}>
                      <Box 
                        display="flex" 
                        justifyContent="space-between" 
                        alignItems="flex-start"
                        flexDirection={isSmallMobile ? "column" : "row"}
                        gap={isSmallMobile ? 2 : 0}
                      >
                        <Box sx={{ width: isSmallMobile ? "100%" : "85%" }}>
                          <Typography 
                            variant={isSmallMobile ? "h6" : "h6"} 
                            fontWeight="bold"
                            sx={{ fontSize: isSmallMobile ? "1rem" : "1.25rem", color: "#002B5B" }}
                          >
                            {work.jobTitle} @ {work.employer}
                          </Typography>
                          <Typography 
                            variant="subtitle2" 
                            sx={{ fontSize: isSmallMobile ? "0.8rem" : "0.875rem", color: "#0D4C8B" }}
                          >
                            {work.companyName} {work.companyName && work.location ? "|" : ""} {work.location}
                          </Typography>
                          <Typography 
                            variant="body2" 
                            sx={{ fontSize: isSmallMobile ? "0.75rem" : "0.875rem", color: "#0288D1" }}
                          >
                            {work.startMonth} {work.startYear} –{" "}
                            {work.current
                              ? "Present"
                              : `${work.endMonth || ""} ${work.endYear || ""}`}
                          </Typography>
                          {work.description && (
                            <Typography 
                              variant="body1" 
                              mt={1}
                              sx={{ 
                                whiteSpace: 'pre-wrap',
                                fontSize: isSmallMobile ? "0.875rem" : "1rem",
                                color: "#0D4C8B",
                                '& strong': { fontWeight: 'bold' },
                                '& em': { fontStyle: 'italic' },
                                '& u': { textDecoration: 'underline' }
                              }}
                              dangerouslySetInnerHTML={{ 
                                __html: formatDescription(work.description)
                              }}
                            />
                          )}
                        </Box>
                        <Box 
                          display="flex" 
                          gap={1}
                          sx={{ 
                            width: isSmallMobile ? "100%" : "auto",
                            justifyContent: isSmallMobile ? "flex-end" : "flex-start"
                          }}
                        >
                          <IconButton 
                            onClick={() => handleEdit(index)}
                            aria-label="edit"
                            size={isSmallMobile ? "small" : "medium"}
                            sx={{ color: "#0288D1" }}
                          >
                            <Edit fontSize={isSmallMobile ? "small" : "medium"} />
                          </IconButton>
                          <IconButton 
                            color="error" 
                            onClick={() => handleDelete(index)}
                            aria-label="delete"
                            size={isSmallMobile ? "small" : "medium"}
                          >
                            <Delete fontSize={isSmallMobile ? "small" : "medium"} />
                          </IconButton>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography 
                  textAlign="center" 
                  color="text.secondary"
                  sx={{ fontSize: isSmallMobile ? "0.875rem" : "1rem" }}
                >
                  No work experiences found
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>

        {/* ✅ Go Back and Next buttons */}
        <Box 
          display="flex" 
          justifyContent="space-between" 
          mt={4}
          flexDirection={isSmallMobile ? "column" : "row"}
          gap={isSmallMobile ? 2 : 0}
        >
          <Button 
            variant="outlined" 
            onClick={handleGoBack}
            sx={{
              width: isSmallMobile ? "100%" : "auto",
              borderColor: "#002B5B",
              color: "#002B5B",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
                backgroundColor: "rgba(2, 136, 209, 0.04)",
              },
            }}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#002B5B",
              "&:hover": { backgroundColor: "#0288D1" },
              width: isSmallMobile ? "100%" : "auto",
            }}
            onClick={() =>
              navigate("/EducationTips", {
                state: { selectedTemplate, selectedTheme },
              })
            }
          >
            Next
          </Button>
        </Box>
      </Box>

      {/* ✅ ADDED: Student Popup Dialog */}
      <Dialog
        open={studentDialog}
        onClose={() => setStudentDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: "2px solid #B3D9F7",
            maxWidth: "420px",
            width: "100%",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#002B5B",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "1.1rem",
            py: 2,
          }}
        >
          🎓 Student Profile Detected
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2, px: 3 }}>
          <Typography
            variant="body1"
            sx={{ color: "#0D4C8B", lineHeight: 1.8, mb: 1 }}
          >
            You entered as a <strong>Student</strong>. Work experience cannot be
            added for student profiles.
          </Typography>
          <Typography variant="body2" sx={{ color: "#0288D1" }}>
            If you have work experience, please go back to the questionnaire and
            select <strong>"No"</strong> for the student question.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1, flexWrap: "wrap" }}>
          <Button
            variant="outlined"
            onClick={() => setStudentDialog(false)}
            sx={{
              borderColor: "#002B5B",
              color: "#002B5B",
              borderRadius: 2,
              textTransform: "none",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
                backgroundColor: "rgba(2,136,209,0.04)",
              },
            }}
          >
            Close
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setStudentDialog(false);
              navigate("/experience-level");
            }}
            sx={{
              borderColor: "#002B5B",
              color: "#002B5B",
              borderRadius: 2,
              textTransform: "none",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
                backgroundColor: "rgba(2,136,209,0.04)",
              },
            }}
          >
            Go to Questionnaire
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setStudentDialog(false);
              navigate("/EducationTips", {
                state: { selectedTemplate, selectedTheme },
              });
            }}
            sx={{
              backgroundColor: "#002B5B",
              borderRadius: 2,
              textTransform: "none",
              "&:hover": { backgroundColor: "#0288D1" },
            }}
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>
      {/* ✅ ADDED: Secondary School Popup Dialog */}
      <Dialog
        open={secondaryDialog}
        onClose={() => setSecondaryDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: "2px solid #B3D9F7",
            maxWidth: "420px",
            width: "100%",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#002B5B",
            color: "#fff",
            fontWeight: "bold",
            fontSize: "1.1rem",
            py: 2,
          }}
        >
          📚 Education Level Notice
        </DialogTitle>
        <DialogContent sx={{ pt: 3, pb: 2, px: 3 }}>
          <Typography
            variant="body1"
            sx={{ color: "#0D4C8B", lineHeight: 1.8, mb: 1 }}
          >
            You selected <strong>Secondary School</strong> as your education level. Work experience typically cannot be added at this level.
          </Typography>
          <Typography variant="body2" sx={{ color: "#0288D1" }}>
            If you have work experience, please go back to the questionnaire and select the correct education level and details.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1, flexWrap: "wrap" }}>
          <Button
            variant="outlined"
            onClick={() => setSecondaryDialog(false)}
            sx={{
              borderColor: "#002B5B",
              color: "#002B5B",
              borderRadius: 2,
              textTransform: "none",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
                backgroundColor: "rgba(2,136,209,0.04)",
              },
            }}
          >
            Close
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setSecondaryDialog(false);
              navigate("/experience-level");
            }}
            sx={{
              borderColor: "#002B5B",
              color: "#002B5B",
              borderRadius: 2,
              textTransform: "none",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
                backgroundColor: "rgba(2,136,209,0.04)",
              },
            }}
          >
            Go to Questionnaire
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setSecondaryDialog(false);
              navigate("/EducationTips", {
                state: { selectedTemplate, selectedTheme },
              });
            }}
            sx={{
              backgroundColor: "#002B5B",
              borderRadius: 2,
              textTransform: "none",
              "&:hover": { backgroundColor: "#0288D1" },
            }}
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default WorkExperienceList;